import React from 'react';

import { OnClick } from '@rbilabs/components-library';

import { useSetLoyaltyCardRewardsTierMutation } from 'generated/rbi-graphql';
import { useLoyaltyActiveCard } from 'hooks/loyalty';
import useEffectOnce from 'hooks/use-effect-once';
import { TimsRewardsPoints } from 'pages/account/tims-rewards/shared-onboarding-modal-components/tims-rewards-points';
import { RewardsDropdown } from 'pages/cart/cart-reward-dropdown';
import { useCustomizableContent } from 'state/customizable-content';

import RewardsUnavailable from '../rewards-unavailable';
import { ContentBlock } from '../styled';

import { ScanPassAndPhysicalCardContent, ScanQRContent, ScanRewardsManagement } from './components';
import { RewardsWrapper } from './scan-rewards.styled';

interface LoyaltyRewards {
  onDismiss: OnClick;
}

export const ScanRewards: React.FC<LoyaltyRewards> = ({ onDismiss }): JSX.Element => {
  const { loyaltyDetails, activeCard, loading } = useLoyaltyActiveCard();
  const { requestLoyaltyCustomizableContent } = useCustomizableContent();
  const [
    setLoyaltyCardRewardsTier,
    { loading: loadingTier },
  ] = useSetLoyaltyCardRewardsTierMutation();

  useEffectOnce(requestLoyaltyCustomizableContent);

  return (
    <RewardsWrapper>
      <RewardsUnavailable />
      <ContentBlock margin="0">
        <TimsRewardsPoints points={loyaltyDetails ? loyaltyDetails.points : 0} />
        <RewardsDropdown
          radioButtonName="scan-page-rewards-dropdown-reward-tier"
          setSelectedRewardsTier={setLoyaltyCardRewardsTier}
          showHeader={false}
        />
      </ContentBlock>
      <ScanQRContent loading={loading} loadingTier={loadingTier} activeCard={activeCard} />
      <ScanRewardsManagement />
      <ScanPassAndPhysicalCardContent onDismiss={onDismiss} />
    </RewardsWrapper>
  );
};

export default ScanRewards;
